import React from 'react';
import { motion } from 'framer-motion';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  eyebrow?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  align = 'left',
  eyebrow,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      className={`mb-10 sm:mb-12 ${align === 'center' ? 'text-center mx-auto' : 'text-left'}`}
    >
      {eyebrow && (
        <p className={`ui-eyebrow mb-3 ${align === 'center' ? 'mx-auto' : ''}`}>{eyebrow}</p>
      )}
      <h2 className={`ui-section-title mb-3 ${align === 'center' ? 'mx-auto' : ''}`}>{title}</h2>
      {subtitle && (
        <p className={`ui-section-subtitle ${align === 'center' ? 'mx-auto' : ''}`}>{subtitle}</p>
      )}
    </motion.div>
  );
};

export default SectionHeader;
